module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"cannotRecognizeText":"Impossibile analizzare l\u0027immagine"}}')
  delete Component.options._Ctor
}
